import { createSelector } from 'reselect'

const getClientProfile = state => state.client

export const getClientProfileComplete = createSelector(
  [ getClientProfile ], (client) => client.clientFirstName && client.clientLastName && client.email
)

export const welcomeNames = createSelector(
  [ getClientProfile ], (client) => {
    if (client.clientFirstName && client.partnerFirstName) {
      return `${client.clientFirstName} & ${client.partnerFirstName}`
    } else if (client.clientFirstName) {
      return client.clientFirstName
    } else {
      return null
    }
  }
)



// WEBPACK FOOTER //
// ./src/selectors/client.js